import React from 'react';

import cn from 'classnames';

import { IConDefaultType } from '..';

export enum UserIconVariant {
  DEFAULT = 'default',
  LARGE = 'large',
}

interface IUserIconProps extends IConDefaultType {
  variant?: UserIconVariant;
}

function UserIcon({ color, className, size = 24, rotate, flip, variant = UserIconVariant.DEFAULT }: IUserIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === UserIconVariant.DEFAULT && (
        <svg width="124" height="114" viewBox="0 0 124 114" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_6315_242235"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="124"
            height="114"
          >
            <rect width="124" height="114" rx="12" transform="matrix(-1 0 0 1 124 0)" fill="white" />
          </mask>
          <g mask="url(#mask0_6315_242235)">
            <path
              d="M61.9981 65.2C76.3348 65.2 88 51.1851 88 33.9545C88 18.188 77.7943 8 61.9981 8C46.2057 8 36 18.188 36 33.9545C36 51.1845 47.6646 65.2 61.9981 65.2Z"
              fill={color || '#97A7B0'}
            />
            <path
              d="M52 73C29.9086 73 12 90.9086 12 113V135C12 146.046 20.9543 155 32 155H92C103.046 155 112 146.046 112 135V113C112 90.9086 94.0914 73 72 73H52Z"
              fill={color || '#97A7B0'}
            />
          </g>
          <rect y="112" width="112" height="2" fill="url(#paint0_linear_6315_242235)" />
          <path d="M0 90H39C45.6274 90 51 95.3726 51 102C51 108.627 45.6274 114 39 114H0V90Z" fill="#131415" />
          <path
            d="M18.184 106.038H21.356V107H17.001V97.939H18.184V106.038ZM29.1123 103.165C29.1123 103.39 29.0993 103.629 29.0733 103.88H23.3793C23.4227 104.582 23.661 105.132 24.0943 105.531C24.5363 105.921 25.0693 106.116 25.6933 106.116C26.2047 106.116 26.6293 105.999 26.9673 105.765C27.314 105.522 27.5567 105.202 27.6953 104.803H28.9693C28.7787 105.488 28.3973 106.047 27.8253 106.48C27.2533 106.905 26.5427 107.117 25.6933 107.117C25.0173 107.117 24.4107 106.965 23.8733 106.662C23.3447 106.359 22.9287 105.93 22.6253 105.375C22.322 104.812 22.1703 104.162 22.1703 103.425C22.1703 102.688 22.3177 102.043 22.6123 101.488C22.907 100.933 23.3187 100.509 23.8473 100.214C24.3847 99.9107 25 99.759 25.6933 99.759C26.3693 99.759 26.9673 99.9063 27.4873 100.201C28.0073 100.496 28.406 100.903 28.6833 101.423C28.9693 101.934 29.1123 102.515 29.1123 103.165ZM27.8903 102.918C27.8903 102.467 27.7907 102.082 27.5913 101.761C27.392 101.432 27.119 101.185 26.7723 101.02C26.4343 100.847 26.0573 100.76 25.6413 100.76C25.0433 100.76 24.532 100.951 24.1073 101.332C23.6913 101.713 23.453 102.242 23.3923 102.918H27.8903ZM33.5729 100.851H32.0779V107H30.8949V100.851H29.9719V99.876H30.8949V99.369C30.8949 98.5717 31.0985 97.991 31.5059 97.627C31.9219 97.2543 32.5849 97.068 33.4949 97.068V98.056C32.9749 98.056 32.6065 98.16 32.3899 98.368C32.1819 98.5673 32.0779 98.901 32.0779 99.369V99.876H33.5729V100.851ZM36.3952 100.851V105.05C36.3952 105.397 36.4688 105.644 36.6162 105.791C36.7635 105.93 37.0192 105.999 37.3832 105.999H38.2542V107H37.1882C36.5295 107 36.0355 106.848 35.7062 106.545C35.3768 106.242 35.2122 105.743 35.2122 105.05V100.851H34.2892V99.876H35.2122V98.082H36.3952V99.876H38.2542V100.851H36.3952Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_6315_242235"
              x1="112"
              y1="112.854"
              x2="95.6176"
              y2="112.854"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopOpacity="0.01" />
              <stop offset="1" />
            </linearGradient>
          </defs>
        </svg>
      )}
      {variant === UserIconVariant.LARGE && (
        <svg viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.3">
            <g clipPath="url(#clip0_9890_174156)">
              <rect width="400" height="400" rx="200" fill="#8A8A8A" />
              <mask
                id="mask0_9890_174156"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="400"
                height="400"
              >
                <circle cx="200" cy="200" r="200" fill="white" />
              </mask>
              <g mask="url(#mask0_9890_174156)">
                <path
                  d="M199.993 272.444C255.747 272.444 301.111 217.942 301.111 150.934C301.111 89.6199 261.422 50 199.993 50C138.578 50 98.889 89.6199 98.889 150.934C98.889 217.94 144.251 272.444 199.993 272.444Z"
                  fill={color || '#D8D8D8'}
                />
                <path
                  d="M161.111 302.778C75.2002 302.778 5.55566 372.422 5.55566 458.333V543.889C5.55566 586.844 40.378 621.667 83.3334 621.667H316.667C359.622 621.667 394.445 586.844 394.445 543.889V458.333C394.445 372.422 324.8 302.778 238.889 302.778H161.111Z"
                  fill={color || '#D8D8D8'}
                />
              </g>
            </g>
          </g>
          <defs>
            <clipPath id="clip0_9890_174156">
              <rect width="400" height="400" rx="200" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </i>
  );
}

export default UserIcon;
